import { apiRequest } from '@/api/request.js'

const appendQueryParam = (url, key, value) => {
  if (value === undefined || value === null || value === '') {
    return url
  }
  return `${url}${url.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(value)}`
}

export const listNotices = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ma/notice',
    method: 'GET'
  })
}
export const getNoticeInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ma/notice/info',
    method: 'GET'
  })
}
export const listHotSearchKeywords = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/hot_search/list',
    method: 'GET'
  })
}
export const getPlatformDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/platform_detail/get_platform_detail',
    method: 'GET'
  })
}
export const getPlatformModeConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ma/platform_mode_config/info',
    method: 'GET'
  })
}
export const getPlatformDetailUrl = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/platform_detail/get_url',
    method: 'GET'
  })
}
export const getTidAppId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/web_config/get_tid_app_id',
    method: 'GET'
  })
}
export const getPaymentSwitchConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/sys_config/get_payment_switch',
    method: 'GET'
  })
}
export const getServiceProtocolConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/sys_config/service_protocol',
    method: 'GET'
  })
}
export const getPrivacyProtocolConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/sys_config/privacy_protocol',
    method: 'GET'
  })
}
export const getPaySettlementTypeConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/sys_config/pay_settlement_type',
    method: 'GET'
  })
}
export const listHomeBanners = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/index_img/list',
    method: 'GET'
  })
}
export const getShopHeaderInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/shop_detail/head_info',
    method: 'GET'
  })
}
export const listShopDetailPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/shop_detail/page',
    method: 'GET'
  })
}
export const getShopHomeRenovation = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/shop_renovation/get_home',
    method: 'GET'
  })
}
export const getFlashShopHomeRenovation = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/flash/shop_renovation/get_home',
    method: 'GET'
  })
}
export const getShopRenovationDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/shop_renovation/get_renovation_by_id',
    method: 'GET'
  })
}
export const getShopCompany = (params = {}) => {
  const { shopId, ...requestParams } = params
  return apiRequest({
    ...requestParams,
    url: `/mall4cloud_admin/ua/shop_company/${shopId}`,
    method: 'GET'
  })
}
export const getWebActivityConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/web_config/get_activity',
    method: 'GET'
  })
}
export const queryCollectedShopCount = (params = {}) => {
  const type = params?.data?.type
  const usage = params?.data?.usage
  let url = '/mall4cloud_admin/user_collection_shop/count'
  url = appendQueryParam(url, 'type', type)
  url = appendQueryParam(url, 'usage', usage)
  return apiRequest({
    ...params,
    url,
    method: 'GET'
  })
}
export const listCollectedShopPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/user_collection_shop/page',
    method: 'GET'
  })
}
export const checkShopCollectionStatus = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/user_collection_shop/ma/is_collection',
    method: 'GET'
  })
}
export const toggleShopCollection = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/user_collection_shop/add_or_cancel',
    method: 'POST'
  })
}

export const getDistributionSysConfig = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_admin/ua/app/sys_config/distribution',
    method: 'GET'
  })
}
